/**
 * 数値（小数点数）文字列入力フィールド
 * @param props
 * @returns
 */
const InputRealNumberText = ({ val, onChange, min = 0 }) => {
  return (
    <input
      type="number"
      step={"any"}
      value={val}
      onChange={e => onChange(e.target.value)}
      min={min}
      required
    />
  );
};
export default InputRealNumberText;
